function createMarkupTrailer(path) {
  return `<iframe allow="fullscreen" frameborder="0" src="${path}"></iframe>`;
}
export default createMarkupTrailer;
